const Home = {
    aos() {
        AOS.init({
            offset: 50,
            once: true
        });
    },

    infinityScroll() {
        const viewMoreButton = document.getElementById("loadmore");
        let pic;

        if (document.querySelector("a.older-posts")) {
            let infScroll = new InfiniteScroll(".section-loop", {
                path: 'a.older-posts',
                append: '#loop-wrap',
                history: false,
                button: viewMoreButton,
                hideNav: '.pagination',
                scrollThreshold: false
            });

            infScroll.on( 'append', function( body, path, items, response ) {
                pic = document.querySelectorAll(".lazyload:not([style])");
                lazyload(pic);

                const labels = document.querySelectorAll('.label.fun:not(.more-block__tags)');
                labels && labels.forEach(item => item.innerText = '🤡🤡🤡');
            });
        }
        if (numberPage < 2) {
            viewMoreButton.parentNode.removeChild(viewMoreButton);
        }
    },

    swiper() {
        const swiper = new Swiper(".swiper", {
            slidesPerView: 1,
            grabCursor: true,
            loop: true,
            speed: 500,
            autoplay: {
                delay: '7000',
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            effect: "cards",
            breakpoints: {
                479: {
                    effect: "creative",
                    creativeEffect: {
                        prev: {
                            translate: ['-100%', 0, 0],
                        },
                        next: {
                            translate: ['100%', 0, 0],
                        },
                    },
                }
            },
        });

        window.addEventListener('resize', () => {
            swiper.update();
        })
    },

    libs() {
        this.aos();
        this.swiper();
        this.infinityScroll()
    }
}

document.addEventListener('DOMContentLoaded', () => {
    Home.libs();
});
